import { forwardRef, Fragment } from 'react';
import { Field, TranslationValue, Typography } from '@prenuvo/halo-web';

import { TextArea, TextAreaProps } from './text-area.component';

export interface TextAreaFieldProps extends TextAreaProps {
  caption?: string;
  isRequired?: boolean;
  label: string;
  translationValue?: TranslationValue;
}

export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(
  function TextAreaField(
    { caption, isDisabled, isInvalid, isRequired, label, translationValue, ...props },
    ref,
  ) {
    const TRANSLATION_VALUE = {
      ...translationValue,
      ...(isRequired
        ? {
            required: (
              <Fragment key="required">
                <span className="text-text-secondary-error-base">*</span>
              </Fragment>
            ),
          }
        : undefined),
    };

    return (
      <Field
        caption={caption}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        translationValue={TRANSLATION_VALUE}
      >
        <Typography
          as="label"
          htmlFor={props.id}
          translationKey={label}
          values={TRANSLATION_VALUE}
        />

        <TextArea
          className="mt-2"
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          ref={ref}
          {...props}
        />
      </Field>
    );
  },
);
